import { ROUTER_TYPE } from '../types/enums/router-type.enum';
import { LOCATION_DEPLOYMENT_STATUS } from '../types/enums/location-status.enum';
import { generateNumberOptions } from '../components/ATA/ACSBaseConfigForm/options/acsOptions';
import { SipRegistrationStatus } from '../types/did/did.type';
import { sipRegistrationStatusToString } from '../components/Other/SipRegistrationStatusDot/SipRegistrationStatusDot';
import { TcServiceTypeCategory } from '../types/enums/tc-service-type-category.enum';
import { serviceCategoryLabel } from '../features/tcServices/tcServices.config';
import { HeartbeatStatus } from '../types/ulare/ulare.types';
import { TICKET_PRIORITY } from '../types/enums/ticket-priority.type';
import { LeadLogEnum } from '../types/leads/lead-log.type';
import { BandwidthPhoneTypeEnum } from '../types/enums/bandwidth-phone-type.enum';
import { OrigRouteCosDestClassDestType } from '../types/csrp/csrp.type';
import { TicketDepartment } from '../types/enums/ticket-department.enum';
import { TICKET_ACTION } from '../types/enums/ticket-action.type';
import { IssueTrackerStatus } from '../types/enums/issue-tracker-status.enum';
import { IssueTrackerCode } from '../types/enums/issue-tracker-code.enum';
import { CountryStatus } from '../types/enums/country-status.enum';
import { CountryCategory } from '../types/enums/country-category.enum';
import { AsyncTaskStatus } from '../types/enums/async-task-status.enum';
import { BuildingType, CellCarrier, SignalStrength, WallMountingMaterial } from '../types/enums/site-readiness.enum';
import { AsyncTaskTypeType } from '../types/enums/async-task-type.enum';
import { PORT_REQUEST_STATUS } from '../types/enums/port-request-status.enum';
import { AlarmDeliveryStatus } from '../types/enums/alarm-delivery-status.enum';

export const statusSMSSimOptions = [
  { id: 'Active', name: 'Active' },
  { id: 'Inactive', name: 'Inactive' },
  { id: 'Blocked', name: 'Blocked' },
  { id: 'Cancelled', name: 'Cancelled' },
];

export const assignToOptions = [
  { id: 'pbx', name: 'PBX' },
  { id: 'pri', name: 'PRI' },
];

export const countryStatusOptions = [
  { id: CountryStatus.ENABLED_FOR_ALL, name: 'All Enabled' },
  { id: CountryStatus.DISABLED_FOR_ALL, name: 'None Enabled' },
  { id: CountryStatus.ENABLED_FOR_SOME, name: 'Some Enabled' },
];

export const countryCategoryOptions = [
  { id: CountryCategory.NA, name: 'North America' },
  { id: CountryCategory.EMEA, name: 'Europe, Middle East, Africa' },
  { id: CountryCategory.UK, name: 'United Kingdom' },
  { id: CountryCategory.APAC, name: 'Asia Pacific' },
  { id: CountryCategory.LATAM, name: 'Latin America' },
];

export const TICKET_TYPE = {
  SUPPORT: 'Support request',
  ACCOUNTING: 'Accounting request',
  PORT_REQUEST: 'Port request',
  ORDER: 'Order',
};

export enum ExternalSystemProvider {
  ALIANZA_PBX = 'ALIANZA_PBX',
  ALIANZA_TELCO = 'ALIANZA_TELCO',
  SKYSWITCH_PBX = 'SKYSWITCH_PBX',
  SKYSWITCH_TELCO = 'P00',
  NETSAPIENS_PBX = 'NETSAPIENS_PBX',
  RING_CENTRAL = 'RING_CENTRAL',
  BANDWIDTH = 'BW',
  TWILIO = 'TWILIO',
  QUESTBLUE = 'P03',
  SINCH = 'SinchFAX',
  MEGASWITCH_PBX = 'MegaSwitch-US',
  MEGASWITCH_SYSTEM_PBX = 'MegaSwitchSystem',
  FAX_BACK_PBX = 'SecureFAX',
  SECURE_ALARM = 'P007',
  BYO_TELCO = 'BYO',
  BYO_PBX = 'BYO_PBX',
  ROUTE_TRUST_TELCO = 'P04',
  FAX_API_PBX = 'FAX_API_PBX',
  VERIZON_MOBILE_CARRIER = 'VERIZON_MOBILE_CARRIER',
  TEAL_MOBILE_CARRIER = 'TEAL_MOBILE_CARRIER',
  GDMS_SERVICE = 'GDMS_SERVICE',
  PRM_CRM_BRIDGE = 'PRM_CRM_BRIDGE',
  CSRP_MEGASWITCH = 'CSRP_MEGASWITCH',
  TECHLINK = 'TECHLINK',
}

export enum EXTERNAL_SYSTEM_PROVIDER_NAMES {
  P00 = 'P00',
  P03 = 'P03',
  P007 = 'P007',
  BANDWIDTH = 'BW',
  P04 = 'P04',
  ALIANZA_TELCO = 'ALIANZA_TELCO',
  SINCH = 'SinchFAX',
}

export enum EXTERNAL_SYSTEM_NAMES {
  SKYSWITCH = 'SS-23107',
  MEGASWITCH = 'MegaSwitch-US',
  FAX_BACK = 'SecureFAX',
}

export const ORDER_TYPE = {
  ORDER: 'Order',
  RESELLER_ADMIN_ORDER: 'Reseller Admin Order',
};

export const EQUIPMENT_GROUP_PREVIEW_HASH_TYPE = {
  routers: 'router',
  batteries: 'battery',
  atas: 'atas',
  acs: 'acs',
  equipment_group: 'equipment-group',
  enclosures: 'enclosures',
  power_cycles: 'power-cycles',
  tc_sims: 'tc-sim',
  dialer: 'dialer',
};

export const CURRENT_STATUS = {
  BLACK: -2,
  ABNORMAL: -1,
  UNDEFINED: 0,
  OFFLINE: 1,
  ALERT: 2,
  ONLINE: 3,
};

export const portRequestStatusNames = {
  [PORT_REQUEST_STATUS.UNKNOWN]: 'Unknown',
  [PORT_REQUEST_STATUS.CREATED]: 'Created',
  [PORT_REQUEST_STATUS.CREATED_DRAFT]: 'Created Draft',
  [PORT_REQUEST_STATUS.UPLOADED_FILES]: 'Uploaded Files',
  [PORT_REQUEST_STATUS.SENT]: 'Sent',
  [PORT_REQUEST_STATUS.DIDS_CREATED]: 'DIDs Created',
  [PORT_REQUEST_STATUS.TEMP_DIDS_BOUGHT]: 'Temp DIDs Bought',
  [PORT_REQUEST_STATUS.PORTED]: 'Ported',
  [PORT_REQUEST_STATUS.FOC_RECEIVED]: 'FOC Received',
  [PORT_REQUEST_STATUS.CANCELED]: 'Canceled',
  [PORT_REQUEST_STATUS.EXCEPTION]: 'Exception',
  [PORT_REQUEST_STATUS.COMPLETED]: 'Completed',
};

export const portRequestStatusOptions = Object.values(PORT_REQUEST_STATUS).map(value => ({
  name: portRequestStatusNames[value],
  id: value,
}));

export const serviceCategoryOptions = Object.values(TcServiceTypeCategory).map(v => ({
  id: v,
  name: serviceCategoryLabel(v),
}));

export const DIALER_STATUS = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  UNDEFINED: 'Undefined',
};

export const dialerOptions = Object.values(DIALER_STATUS).map(value => ({
  name: value,
  id: value,
}));

export const statusNames = {
  [CURRENT_STATUS.ABNORMAL]: 'Abnormal',
  [CURRENT_STATUS.UNDEFINED]: 'Undefined',
  [CURRENT_STATUS.OFFLINE]: 'Offline',
  [CURRENT_STATUS.ALERT]: 'Partially online',
  [CURRENT_STATUS.ONLINE]: 'Online',
  [CURRENT_STATUS.BLACK]: 'Disabled',
};

export const heartbeatStatusToCurrentStatus = {
  [HeartbeatStatus.INIT]: CURRENT_STATUS.ABNORMAL,
  [HeartbeatStatus.SUCCESS]: CURRENT_STATUS.ONLINE,
  [HeartbeatStatus.ERROR]: CURRENT_STATUS.OFFLINE,
};

export const routerTypesOptions = Object.values(ROUTER_TYPE).map(value => ({
  name: value,
  id: value,
}));

export const pendingRouterTypesOptions = Object.values([
  ROUTER_TYPE.ATEL,
  ROUTER_TYPE.BECENTRAL,
  ROUTER_TYPE.CSG,
  ROUTER_TYPE.CRADLE_POINT,
  ROUTER_TYPE.IN_HAND_NETWORKS,
  ROUTER_TYPE.PEP_WAVE,
  ROUTER_TYPE.SIERRA_WIRELESS,
  ROUTER_TYPE.TELTONIKA_NETWORKS,
]).map(value => ({
  name: value,
  id: value,
}));

export const issueTrackerStatusOptions = [
  { id: IssueTrackerStatus.Unresolved, name: 'Unresolved' },
  { id: IssueTrackerStatus.Resolved, name: 'Resolved' },
  { id: IssueTrackerStatus.Ignored, name: 'Ignored' },
  { id: IssueTrackerStatus.CantResolve, name: "Can't Resolve" },
];

export const issueTrackerCodeOptions = [
  { id: IssueTrackerCode.Other, name: 'Other' },
  { id: IssueTrackerCode.SierrawirelessUnauthorized, name: 'Sierra Wireless Unauthorized' },
  { id: IssueTrackerCode.CradlepointUnauthorized, name: 'Cradlepoint Unauthorized' },
  { id: IssueTrackerCode.InhandUnauthorized, name: 'InHand Unauthorized' },
  { id: IssueTrackerCode.PepwaveUnauthorized, name: 'Pepwave Unauthorized' },
  { id: IssueTrackerCode.SkyswitchPbxUnauthorized, name: 'Skyswitch PBX Unauthorized' },
  { id: IssueTrackerCode.SkyswitchTelcoUnauthorized, name: 'Skyswitch Telco Unauthorized' },
  { id: IssueTrackerCode.E911ProvisioningError, name: 'E911 Provisioning Error' },
  { id: IssueTrackerCode.CradlepointCantGetInterfaceData, name: "Cradlepoint Can't Get Interface Data" },
  { id: IssueTrackerCode.BoBoOverridesNotFound, name: 'BoBo Overrides Not Found' },
  { id: IssueTrackerCode.UpdateServiceLocationFailed, name: 'Update Service Location Failed' },
  { id: IssueTrackerCode.CancelServiceFailed, name: 'Cancel Service Failed' },
  { id: IssueTrackerCode.DeleteDidFromTelcoFailed, name: 'Delete DID From Telco Failed' },
  { id: IssueTrackerCode.ConfigureDidFailed, name: 'Configure DID Failed' },
  { id: IssueTrackerCode.ConfigureDide911Failed, name: 'Configure DID E911 Failed' },
  { id: IssueTrackerCode.RoutingDidFailed, name: 'Routing DID Failed' },
  { id: IssueTrackerCode.CreateServicesFailed, name: 'Create Services Failed' },
];

export const ATA_TYPES = {
  GS: 'GS',
  ACS: 'ACS',
  POTSCAST: 'POTSCAST',
  VACS: 'VACS',
};

export enum ATA_TYPE {
  GS = 'GS',
  ACS = 'ACS',
  VACS = 'VACS',
  POTSCAST = 'POTSCAST',
}

export const ataTypesOptions = Object.values(ATA_TYPE)
  // TODO: instead remove VACS from the enum above, but it is still used in some places
  .filter(value => value !== ATA_TYPE.VACS)
  .map(value => ({
    name: value,
    id: value,
  }));

export const AlianzaPlatformType = [
  {
    id: 'CPE1',
    name: 'Business Line',
  },
  {
    id: 'CPE2',
    name: 'Business Cloud Communications',
  },
];

const defaultExternalSystemProviders = [
  {
    id: ExternalSystemProvider.SKYSWITCH_PBX,
    name: 'SkySwitch PBX',
  },
  {
    id: ExternalSystemProvider.NETSAPIENS_PBX,
    name: 'Netsapiens PBX',
  },
  {
    id: ExternalSystemProvider.ALIANZA_PBX,
    name: 'Alianza PBX',
  },
  { id: ExternalSystemProvider.BANDWIDTH, name: 'Bandwidth.com TELCO' },
  {
    id: ExternalSystemProvider.SKYSWITCH_TELCO,
    name: 'SkySwitch TELCO',
  },
  {
    id: ExternalSystemProvider.QUESTBLUE,
    name: 'QuestBlue TELCO',
  },
  {
    id: ExternalSystemProvider.ROUTE_TRUST_TELCO,
    name: 'Route Trust TELCO',
  },
  {
    id: ExternalSystemProvider.SINCH,
    name: 'Sinch TELCO',
  },
  {
    id: ExternalSystemProvider.ALIANZA_TELCO,
    name: 'Alianza TELCO',
  },
  {
    id: ExternalSystemProvider.MEGASWITCH_SYSTEM_PBX,
    name: 'MegaSwitch-System PBX',
  },
  {
    id: ExternalSystemProvider.VERIZON_MOBILE_CARRIER,
    name: 'Verizon Mobile Carrier',
  },
  {
    id: ExternalSystemProvider.TEAL_MOBILE_CARRIER,
    name: 'Teal Mobile Carrier',
  },
  {
    id: ExternalSystemProvider.GDMS_SERVICE,
    name: 'GDMS Service',
  },
  {
    id: ExternalSystemProvider.PRM_CRM_BRIDGE,
    name: 'PRM CRM Bridge',
  },
  {
    id: ExternalSystemProvider.CSRP_MEGASWITCH,
    name: 'CSRP',
  },
  {
    id: ExternalSystemProvider.TECHLINK,
    name: 'TechLink Field Service',
  },
];

const govExternalSystemProviders = [
  { id: ExternalSystemProvider.BANDWIDTH, name: 'Bandwidth.com TELCO' },
  { id: ExternalSystemProvider.QUESTBLUE, name: 'QuestBlue TELCO' },
  { id: ExternalSystemProvider.SINCH, name: 'Sinch TELCO' },
  { id: ExternalSystemProvider.MEGASWITCH_PBX, name: 'MegaSwitch PBX' },
  { id: ExternalSystemProvider.MEGASWITCH_SYSTEM_PBX, name: 'MegaSwitch-System PBX' },
  { id: ExternalSystemProvider.SECURE_ALARM, name: 'Secure Alarm TELCO' },
  { id: ExternalSystemProvider.ROUTE_TRUST_TELCO, name: 'Route Trust TELCO' },
  { id: ExternalSystemProvider.FAX_API_PBX, name: 'Fax API PBX' },
  { id: ExternalSystemProvider.VERIZON_MOBILE_CARRIER, name: 'Verizon Mobile Carrier' },
  { id: ExternalSystemProvider.TEAL_MOBILE_CARRIER, name: 'Teal Mobile Carrier' },
];

export const externalSystemProviders =
  process.env.REACT_APP_GOV === 'true' ? govExternalSystemProviders : defaultExternalSystemProviders;

export const EQUIPMENT_TYPES = {
  ATA_ACS: 'Ata ACS',
  ATA_GS: 'Ata GS',
  BATTERY: 'Battery',
  DIALER: 'Dialer',
  ENCLOSURE: 'Enclosure',
  ROUTER: 'Router',
  SIM: 'SIM',
  POWER_CYCLE: 'PowerCycle',
};

export const equipmentTypesOptions = Object.values(EQUIPMENT_TYPES).map(value => ({ name: value, id: value }));

export const CREDENTIAL_TYPES = {
  Cradlepoint: 'cradlepoint',
  Pepwave: 'pepwave',
  InHand: 'inhandnetworks',
  SierraWireless: 'sierrawireless',
};

export const ADDRESS_STATUS = {
  UNDEFINED: 0,
  NOT_DELIVERABLE: 1,
  DELIVERABLE_WITH_ERROR: 2,
  DELIVERABLE: 3,
  SUPERADMIN_VALIDATED: 4,
};

// San Diego
export const DEFAULT_GEO_COORDINATES = {
  lng: -117.161087,
  lat: 32.715736,
};

export const activeStatusFilterArray = [
  { name: 'All', id: 'all' },
  { name: 'Offline', id: 'offline' },
  { name: 'Online', id: 'online' },
  { name: 'Inactive', id: 'inactive' },
];

export const userActiveStatusFilterArray = [
  { name: 'Online', id: 'online' },
  { name: 'Offline', id: 'offline' },
  { name: 'Suspended', id: 'inactive' },
];

export const userTypeFilterArray = [
  { name: 'Salesperson', id: 'salesperson' },
  { name: 'Customer Success', id: 'customer_success' },
  { name: 'Field Services', id: 'field_services' },
  { name: 'Support Agent', id: 'support_agent' },
];

export const inServiceFilterArray = [
  { name: 'All', id: 'all' },
  { name: 'In Service', id: 'true' },
  { name: 'Not Assigned', id: 'false' },
];

export const cdrsCallResultFilterArray = [
  { name: 'All', id: 'all' },
  { name: 'Cancelled', id: 'Cancelled' },
  { name: 'Answered', id: 'Answered' },
  { name: 'Busy', id: 'Busy' },
  { name: 'Other', id: 'Other' },
  { name: 'Unknown', id: 'Unknown' },
];

export const openStatusFilterArray = [
  { name: 'All', id: '1' },
  { name: 'Open', id: '2' },
  { name: 'Closed', id: '3' },
];

export const orgTypeFilterArray = [
  { name: 'Provider', id: 'reseller' },
  { name: 'Suborganization', id: 'sub_org' },
  { name: 'Second-level suborganization', id: 'second_sub_org' },
  { name: 'BoBo', id: 'bobo' },
  { name: 'TelcoBill', id: 'telcobill' },
  { name: 'Full Service', id: 'full_service' },
];

export const currentStatusFilterArray = [
  { name: 'Abnormal', id: '-1' },
  { name: 'Unknown', id: '0' },
  { name: 'Offline', id: '1' },
  { name: 'Alert', id: '2' },
  { name: 'Online', id: '3' },
];

export const aggregatedStatusFilterArray = [
  { name: 'Online', id: '3' },
  { name: 'Partially online', id: '2' },
  { name: 'Offline', id: '1' },
  { name: 'Undefined', id: '0' },
];

export const locationDeploymentStatusNames = {
  [LOCATION_DEPLOYMENT_STATUS.PLANNED]: 'Planned',
  [LOCATION_DEPLOYMENT_STATUS.PENDING]: 'Pending',
  [LOCATION_DEPLOYMENT_STATUS.ACTIVE]: 'Active',
  [LOCATION_DEPLOYMENT_STATUS.DECOMMISSIONED]: 'Decommissioned',
};

export const locationDeploymentStatusFilterArray = Object.values(LOCATION_DEPLOYMENT_STATUS).map(status => ({
  id: status,
  name: locationDeploymentStatusNames[status],
}));

export const unassignedEquipmentStatus = {
  name: 'Unassigned',
  id: 'unassigned',
};

export const equipmentStatusFilterArray = [
  { name: 'All', id: 'all' },
  { name: 'Allocated', id: 'allocated' },
  { name: 'Not Allocated', id: 'not_allocated' },
  { name: 'In Inventory', id: 'in_inventory' },
];

export const simStatusFilterArray = [
  { id: 'active', name: 'Active' },
  { id: 'suspended', name: 'Suspended' },
  { id: 'deactivated', name: 'Deactivated' },
  { id: 'pending', name: 'Pending' },
];

export const ataPortsStatusFilterAray = [
  { name: 'Online', id: CURRENT_STATUS.ONLINE },
  { name: 'Offline', id: CURRENT_STATUS.OFFLINE },
  { name: 'Abnormal', id: CURRENT_STATUS.ABNORMAL },
  { name: 'Disabled', id: `${CURRENT_STATUS.BLACK}` },
  { name: 'Empty', id: 'empty' },
];

export const sipRegistrationStatusFilterArray = [
  SipRegistrationStatus.Registered,
  SipRegistrationStatus.Unregistered,
  SipRegistrationStatus.Unknown,
].map(status => ({ id: status, name: sipRegistrationStatusToString(status) }));

export const booleanFilterArray = [
  { name: 'All', id: 'all' },
  { name: 'True', id: 'true' },
  { name: 'False', id: 'false' },
];

export const asyncTaskTypeFilterArray = [
  { id: AsyncTaskTypeType.CONNECTION_SYNC_EXTERNAL_LIST, name: 'Connection Sync' },
  { id: AsyncTaskTypeType.CONNECTION_UPDATE_OUR_DB, name: 'Connection Update' },
  { id: AsyncTaskTypeType.CRADLEPOINT_SYNC, name: 'Cradlepoint Sync' },
  { id: AsyncTaskTypeType.CRADLEPOINT_UPDATE, name: 'Cradlepoint Update' },
  { id: AsyncTaskTypeType.SIERRAWIRELESS_SYNC, name: 'Sierra Wireless Sync' },
  { id: AsyncTaskTypeType.SIERRAWIRELESS_UPDATE, name: 'Sierra Wireless Update' },
  { id: AsyncTaskTypeType.PEPWAVE_SYNC, name: 'Pepwave Sync' },
  { id: AsyncTaskTypeType.PEPWAVE_UPDATE, name: 'Pepwave Update' },
  { id: AsyncTaskTypeType.LEAX_SYNC, name: 'LEAX Sync' },
  { id: AsyncTaskTypeType.LEAX_UPDATE, name: 'LEAX Update' },
  { id: AsyncTaskTypeType.INHAND_SYNC, name: 'InHand Sync' },
  { id: AsyncTaskTypeType.INHAND_UPDATE, name: 'InHand Update' },
  { id: AsyncTaskTypeType.TEAL_PLANS_UPDATE, name: 'Teal Plans Update' },
  { id: AsyncTaskTypeType.TEAL_DATA_CONSUMPTIONS_UPDATE, name: 'Teal Data Consumptions Update' },
  { id: AsyncTaskTypeType.BATTERY_BULK_UPLOAD, name: 'Battery Bulk Upload' },
  { id: AsyncTaskTypeType.POWER_CYCLE_BULK_UPLOAD, name: 'PowerCycle Bulk Upload' },
  { id: AsyncTaskTypeType.PENDING_ROUTER_BULK_UPLOAD, name: 'Router Bulk Upload' },
  { id: AsyncTaskTypeType.DIALER_BULK_UPLOAD, name: 'Dialer Bulk Upload' },
  { id: AsyncTaskTypeType.ATA_GS_BULK_UPLOAD, name: 'ATA GS Bulk Upload' },
  { id: AsyncTaskTypeType.ATA_ACS_BULK_UPLOAD, name: 'ATA ACS Bulk Upload' },
  { id: AsyncTaskTypeType.TC_SIM_BULK_UPLOAD, name: 'SIM Bulk Upload' },
  { id: AsyncTaskTypeType.ENCLOSURE_BULK_UPLOAD, name: 'Enclosure Bulk Upload' },
  { id: AsyncTaskTypeType.LOCATION_BULK_UPLOAD, name: 'Location Bulk Upload' },
  { id: AsyncTaskTypeType.USER_BULK_UPLOAD, name: 'User Bulk Upload' },
  { id: AsyncTaskTypeType.E911_PROVISIONING, name: 'E911 Provisioning' },
  { id: AsyncTaskTypeType.DELETE_E911_RECORD, name: 'Delete E911 Record' },
  { id: AsyncTaskTypeType.CONFIGURE_NEW_DID, name: 'Configure New DID' },
  { id: AsyncTaskTypeType.SETUP_XML_UPDATE, name: 'Update Setup XML' },
  { id: AsyncTaskTypeType.FULL_XML_UPDATE, name: 'Update Full XML' },
  { id: AsyncTaskTypeType.GDMS_SETUP_XML_UPDATE, name: 'Cloud Update Setup XML' },
  { id: AsyncTaskTypeType.SKYSWITCH_CREATE_PORT_REQUEST, name: 'Create Port Request' },
  { id: AsyncTaskTypeType.DID_BULK_UPLOAD, name: 'DID Bulk Upload' },
  { id: AsyncTaskTypeType.DID_BULK_ASSIGNMENT_CHANGE, name: 'DID Bulk Assignment Change' },
  { id: AsyncTaskTypeType.IMPORT_DEVICES_FROM_GDMS, name: 'Import Devices from GDMS' },
  { id: AsyncTaskTypeType.CELL_TOWER_ADDRESS_BULK_UPLOAD, name: 'Cell Tower Address Bulk Upload' },
  { id: AsyncTaskTypeType.CELL_TOWER_FILE_SYNC, name: 'Cell Tower File Sync' },
  { id: AsyncTaskTypeType.OKTA_USER_CREATION, name: 'Okta User Creation' },
  { id: AsyncTaskTypeType.OTHER, name: 'Other' },
];

export const asyncTaskStatusFilterArray = [
  { id: AsyncTaskStatus.IN_PROGRESS, name: 'In Progress' },
  { id: AsyncTaskStatus.COMPLETED, name: 'Completed' },
  { id: AsyncTaskStatus.WARNINGS, name: 'Warnings' },
  { id: AsyncTaskStatus.FAILED, name: 'Failed' },
  { id: AsyncTaskStatus.CANCELED, name: 'Canceled' },
];

export const ticketType = {
  SUPPORT_REQUEST: 'Support request',
  ACCOUNTING_REQUEST: 'Accounting request',
};

/** @deprecated use `ORG_LEVEL` from `organization-level.enum.ts` */
export const ORG_LEVEL = {
  TELCLOUD: 0,
  RESELLER: 1,
  SUB_ORG: 2,
  SUB_ORG_1: 3,
};

export const revioOverridesFields = [
  { label: 'ID', id: 'service_id' },
  { label: 'Provider ID', id: 'provider_id' },
  { label: 'Usage Plan Group ID', id: 'usage_plan_group_id' },
];

export const orderStatus = {
  NEW: 'New',
  PROVISIONING_PORTAL: 'Provisioning Portal',
  PROVISIONING_HARDWARE: 'Provisioning Hardware',
  WAITING_ON_SIM_ACTIVATION: 'Waiting on SIM Activation',
  TESTING_LINES: 'Testing Lines',
  READY_TO_SHIP: 'Ready to Ship',
  SHIPPED: 'Shipped',
  CANCELED: 'Canceled',
};
export const orderStatusFilterArray = Object.values(orderStatus).map(value => ({ name: value, id: value }));

export const shipCarrier = {
  UPS: 'UPS',
  FedEx: 'FedEx',
};
export const shipCarrierFilterArray = Object.values(shipCarrier).map(value => ({ name: value, id: value }));

export const shipMethods = {
  GROUND: 'Ground',
  OVERNIGHT: 'Overnight',
};
export const shipMethodsFilterArray = Object.values(shipMethods).map(value => ({ name: value, id: value }));

export const POWER_CYCLE_DEVICE_TYPE = {
  ATA: 'ATA',
  ACS_ATA: 'ACS ATA',
  ROUTER: 'Router',
  DIALER: 'Dialer',
  OTHER: 'Other',
};
export const powerCycleDeviceTypeFilterArray = Object.values(POWER_CYCLE_DEVICE_TYPE).map(value => ({
  name: value,
  id: value,
}));

export const ticketStatus = {
  NEW: 'New',
  OPEN: 'Open',
  // WAITING_FOR_RESPONSE: 'Waiting for response',
  CLOSED: 'Closed',
};

export const revioBoBoCollectionTemplates = [
  { id: 1, name: 'POTSOLVE COLLECTIONS' },
  { id: 2, name: 'ONESOURCE TELCO COLLECTIONS' },
  { id: 3, name: 'SOURCEINC COLLECTIONS' },
];

export const locationInfoPanels = {
  FIRE_PANEL: 'fire_panel',
  SECURITY_PANEL: 'security_panel',
  ELEVATOR_PANEL: 'elevator_panel',
};

export const ticketPriorityDescriptions = {
  [TICKET_PRIORITY.CRITICAL]: 'Critical - All Core Services Down',
  [TICKET_PRIORITY.HIGH]: 'High - Some Core Services Down',
  [TICKET_PRIORITY.MEDIUM]: 'Medium - Portal or Provisioning',
  [TICKET_PRIORITY.LOW]: 'Low - Portal or Feature Request',
};

export const ticketActionElement = {
  [TICKET_ACTION.NEEDS_ATTENTION]: (
    <>
      Needs
      <br />
      Attention
    </>
  ),
  [TICKET_ACTION.WAITING_FOR_RESPONSE]: (
    <>
      Waiting For
      <br />
      Response
    </>
  ),
};

export const ticketDepartmentDescriptions = {
  [TicketDepartment.Accounting]: 'Accounting',
  [TicketDepartment.CustomerSuccess]: 'Customer Success',
  [TicketDepartment.Operations]: 'Operations',
  [TicketDepartment.PartnerSuccess]: 'Partner Success',
  [TicketDepartment.Product]: 'Product',
  [TicketDepartment.Support]: 'Support',
};

export const ticketStatusOptions = Object.values(ticketStatus).map(id => ({ id, name: id }));
export const ticketPriorityOptions = Object.values(TICKET_PRIORITY).map(id => ({
  id,
  name: ticketPriorityDescriptions[id],
}));
export const ticketActionOptions = Object.values(TICKET_ACTION).map(id => ({ id, name: id }));
export const ticketDepartmentOptions = Object.values(TicketDepartment).map(id => ({
  id,
  name: ticketDepartmentDescriptions[id],
}));

export const alarmSignalFormatOptions = [
  { name: 'Contact ID', id: 'contact-id' },
  { name: 'SIA', id: 'sia' },
  { name: 'PULSE4-2', id: 'pulse4-2' },
  { name: 'PULSE3-1', id: 'pulse3-1' },
  { name: 'FSK', id: 'fsk' },
  { name: 'BFSK', id: 'bfsk' },
  { name: 'MODEM-IIIA2', id: 'modem-iiia2' },
  { name: 'MODEM-II', id: 'modem-ii' },
  { name: 'MODEM-IIE', id: 'modem-iie' },
  { name: 'DMP', id: 'modem-dmp' },
  { name: 'SONITROL', id: 'sonitrol' },
];

export const alarmSignalPathOptions = [
  { name: 'PSTN', id: 'pstn' },
  { name: 'IP', id: 'ip' },
  { name: 'ULARE', id: 'ulare' },
];

export const alarmSignalStatusOptions = [
  { name: 'Queued', id: AlarmDeliveryStatus.queued },
  { name: 'Dialing', id: AlarmDeliveryStatus.dialing },
  { name: 'Retry Wait', id: AlarmDeliveryStatus.retry_wait },
  { name: 'Acked', id: AlarmDeliveryStatus.acked },
  { name: 'Failed', id: AlarmDeliveryStatus.failed },
  { name: 'Sent', id: AlarmDeliveryStatus.sent },
  { name: 'Canceled', id: AlarmDeliveryStatus.canceled },
];

export const stateCanadaCodes = [
  {
    name: 'CAN',
    options: [
      { name: 'Alberta', code: 'AB' },
      { name: 'British Columbia', code: 'BC' },
      { name: 'Manitoba', code: 'MB' },
      { name: 'New Brunswick', code: 'NB' },
      { name: 'Newfoundland and Labrador', code: 'NL' },
      { name: 'Nova Scotia', code: 'NS' },
      { name: 'Northwest Territories', code: 'NT' },
      { name: 'Nunavut', code: 'NU' },
      { name: 'Ontario', code: 'ON' },
      { name: 'Prince Edward Island', code: 'PE' },
      { name: 'Québec', code: 'QC' },
      { name: 'Saskatchewan', code: 'SK' },
      { name: 'Yukon', code: 'YT' },
    ],
  },
];

export const stateCodes = [
  {
    name: 'USA',
    options: [
      { name: 'Alabama', code: 'AL' },
      { name: 'Alaska', code: 'AK' },
      { name: 'American Samoa', code: 'AS' },
      { name: 'Arizona', code: 'AZ' },
      { name: 'Arkansas', code: 'AR' },
      { name: 'California', code: 'CA' },
      { name: 'Colorado', code: 'CO' },
      { name: 'Connecticut', code: 'CT' },
      { name: 'Delaware', code: 'DE' },
      { name: 'District Of Columbia', code: 'DC' },
      { name: 'Federated States Of Micronesia', code: 'FM' },
      { name: 'Florida', code: 'FL' },
      { name: 'Georgia', code: 'GA' },
      { name: 'Guam', code: 'GU' },
      { name: 'Hawaii', code: 'HI' },
      { name: 'Idaho', code: 'ID' },
      { name: 'Illinois', code: 'IL' },
      { name: 'Indiana', code: 'IN' },
      { name: 'Iowa', code: 'IA' },
      { name: 'Kansas', code: 'KS' },
      { name: 'Kentucky', code: 'KY' },
      { name: 'Louisiana', code: 'LA' },
      { name: 'Maine', code: 'ME' },
      { name: 'Marshall Islands', code: 'MH' },
      { name: 'Maryland', code: 'MD' },
      { name: 'Massachusetts', code: 'MA' },
      { name: 'Michigan', code: 'MI' },
      { name: 'Minnesota', code: 'MN' },
      { name: 'Mississippi', code: 'MS' },
      { name: 'Missouri', code: 'MO' },
      { name: 'Montana', code: 'MT' },
      { name: 'Nebraska', code: 'NE' },
      { name: 'Nevada', code: 'NV' },
      { name: 'New Hampshire', code: 'NH' },
      { name: 'New Jersey', code: 'NJ' },
      { name: 'New Mexico', code: 'NM' },
      { name: 'New York', code: 'NY' },
      { name: 'North Carolina', code: 'NC' },
      { name: 'North Dakota', code: 'ND' },
      { name: 'Northern Mariana Islands', code: 'MP' },
      { name: 'Ohio', code: 'OH' },
      { name: 'Oklahoma', code: 'OK' },
      { name: 'Oregon', code: 'OR' },
      { name: 'Palau', code: 'PW' },
      { name: 'Pennsylvania', code: 'PA' },
      { name: 'Puerto Rico', code: 'PR' },
      { name: 'Rhode Island', code: 'RI' },
      { name: 'South Carolina', code: 'SC' },
      { name: 'South Dakota', code: 'SD' },
      { name: 'Tennessee', code: 'TN' },
      { name: 'Texas', code: 'TX' },
      { name: 'Utah', code: 'UT' },
      { name: 'Vermont', code: 'VT' },
      { name: 'Virgin Islands', code: 'VI' },
      { name: 'Virginia', code: 'VA' },
      { name: 'Washington', code: 'WA' },
      { name: 'West Virginia', code: 'WV' },
      { name: 'Wisconsin', code: 'WI' },
      { name: 'Wyoming', code: 'WY' },
    ],
  },
  // {
  //   name: 'CAN',
  //   options: [
  //     { name: 'Alberta', code: 'AB' },
  //     { name: 'British Columbia', code: 'BC' },
  //     { name: 'Manitoba', code: 'MB' },
  //     { name: 'New Brunswick', code: 'NB' },
  //     { name: 'Newfoundland and Labrador', code: 'NL' },
  //     { name: 'Nova Scotia', code: 'NS' },
  //     { name: 'Northwest Territories', code: 'NT' },
  //     { name: 'Nunavut', code: 'NU' },
  //     { name: 'Ontario', code: 'ON' },
  //     { name: 'Prince Edward Island', code: 'PE' },
  //     { name: 'Québec', code: 'QC' },
  //     { name: 'Saskatchewan', code: 'SK' },
  //     { name: 'Yukon', code: 'YT' },
  //   ],
  // },
];

export const noAnswerTimeoutOptions = [
  { id: 0, name: 'Never' },
  { id: 5, name: '5' },
  { id: 10, name: '10' },
  { id: 15, name: '15' },
  { id: 20, name: '20' },
  { id: 25, name: '25' },
  { id: 30, name: '30' },
  { id: 35, name: '35' },
  { id: 40, name: '40' },
  { id: 45, name: '45' },
  { id: 50, name: '50' },
  { id: 55, name: '55' },
  { id: 60, name: '60' },
  { id: 90, name: '90' },
  { id: 120, name: '120' },
];

export const agreementType = {
  MASTER_SERVICES_AGREEMENT: 'mse',
  HIPPA: 'hippa',
};

export const DEFAULT_DID_VALUE = { did: '', country_code: '' };

export enum DATE_RANGE {
  all = 'all',
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
  custom = 'custom',
}

export const dateRangeOptions = [
  { id: DATE_RANGE.day, name: 'Day' },
  { id: DATE_RANGE.month, name: 'Month' },
  { id: DATE_RANGE.year, name: 'Year' },
  { id: DATE_RANGE.custom, name: 'Custom Range' },
];

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const requestTypeOptions = [
  { id: 1, name: 'Installation' },
  { id: 2, name: 'Site Survey' },
  { id: 3, name: 'Break Fix' },
  { id: 4, name: 'Custom' },
  { id: 5, name: 'Virtual Site Survey' },
];

export const yesNoOptions = [
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];

export const buildingTypeOptions = [
  { id: BuildingType.Commercial, name: 'Commercial' },
  { id: BuildingType.Residential, name: 'Residential' },
  { id: BuildingType.Industrial, name: 'Industrial' },
  { id: BuildingType.Medical, name: 'Medical' },
  { id: BuildingType.Educational, name: 'Educational' },
  { id: BuildingType.Government, name: 'Government' },
  { id: BuildingType.Retail, name: 'Retail' },
  { id: BuildingType.Other, name: 'Other' },
];

export const wallMountingMaterialOptions = [
  { id: WallMountingMaterial.Drywall, name: 'Drywall' },
  { id: WallMountingMaterial.Plywood, name: 'Plywood' },
  { id: WallMountingMaterial.Concrete, name: 'Concrete' },
  { id: WallMountingMaterial.Other, name: 'Other' },
];

export const signalStrengthOptions = [
  { id: SignalStrength.Excellent, name: 'Excellent' },
  { id: SignalStrength.Good, name: 'Good' },
  { id: SignalStrength.Fair, name: 'Fair' },
  { id: SignalStrength.Poor, name: 'Poor' },
  { id: SignalStrength.NoSignal, name: 'No Signal' },
];

export const cellCarrierOptions = [
  { id: CellCarrier.Verizon, name: 'Verizon' },
  { id: CellCarrier.TMobile, name: 'T-Mobile' },
  { id: CellCarrier.ATT, name: 'AT&T' },
];

export {
  requestedTimeSlotOptions,
  scheduledTimeSlotOptions,
  findRequestedTimeSlot,
  findScheduledTimeSlot,
} from '../features/serviceCalls/serviceCalls.config';

export const BADGE_COLORS = {
  INFO: 'info',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  DARK: 'dark',
  LIGHT: 'light',
  SECONDARY: 'secondary',
  ACCENT: 'accent',
} as const;

export const FILTER_VALUES = {
  ALL: 'all',
} as const;

export const PotscastBoolOpt = [
  { id: '0', name: 'Enable' },
  { id: '1', name: 'Disable' },
];

export const PotscastTransportOpt = [
  { id: '0', name: 'UDP' },
  { id: '1', name: 'TCP' },
  { id: '3', name: 'TLS' },
];

export const PotscastDTMFOpt = [
  { id: '0', name: 'InBand' },
  { id: '1', name: 'RFC2833' },
  { id: '2', name: 'Info' },
  { id: '3', name: 'RFC2833 + Sip Info' },
];

export const PotscastProxyOpt = [
  { id: '0', name: 'Auto' },
  { id: '1', name: 'A-Type' },
  { id: '2', name: 'DNS SRV' },
  { id: '3', name: 'DNS Naptr' },
];

export const PotscastNotBoolOpt = [
  { id: '0', name: 'Disable' },
  { id: '1', name: 'Enable' },
];

export const PotscastAPNModeOpt = [
  { id: 'auto', name: 'Auto' },
  { id: 'manual', name: 'Manual' },
];

export const PotscastAPNPDPOpt = [
  { id: '0', name: 'None' },
  { id: '1', name: 'IPV4V6' },
  { id: '2', name: 'IPV6' },
];

export const PotscastAPNAuthOpt = [
  { id: '0', name: 'None' },
  { id: '1', name: 'CHAP' },
  { id: '2', name: 'PAP' },
];

export const PotscastNatTraversal = [
  { id: '0', name: 'Disable' },
  { id: '1', name: 'Hello' },
  { id: '2', name: 'Option' },
];

export const PotscastNatKeep = [...generateNumberOptions(10, 60, 1)].map(o => ({
  id: `${o.id}`,
  name: `${o.id}sec`,
}));

export const PotscastSIMOpt = [
  { id: '1', name: 'SIM1' },
  { id: '2', name: 'SIM2' },
];

export const PotscastWirelessModeOpt = [
  { id: '1', name: '11b only' },
  { id: '4', name: '11g only' },
  { id: '6', name: '11n only' },
  { id: '0', name: '11b/g mixed mode' },
  { id: '9', name: '11b/g/n mixed mode' },
];

export const PotscastChannelOpt = [
  { id: '0', name: 'Auto (Channel 1)' },
  { id: '1', name: '2412MHz (Channel 1)' },
  { id: '2', name: '2417MHz (Channel 2)' },
  { id: '3', name: '2422MHz (Channel 3)' },
  { id: '4', name: '2427MHz (Channel 4)' },
  { id: '5', name: '2432MHz (Channel 5)' },
  { id: '6', name: '2437MHz (Channel 6)' },
  { id: '7', name: '2442MHz (Channel 7)' },
  { id: '8', name: '2447MHz (Channel 8)' },
  { id: '9', name: '2452MHz (Channel 9)' },
  { id: '10', name: '2457MHz (Channel 10)' },
  { id: '11', name: '2462MHz (Channel 11)' },
];

export const PotscastChannel5GOpt = [
  { id: '0', name: 'Auto (Channel 1)' },
  { id: '36', name: 'Channel 36' },
  { id: '40', name: 'Channel 40' },
  { id: '44', name: 'Channel 44' },
  { id: '48', name: 'Channel 48' },
  { id: '52', name: 'Channel 52' },
  { id: '56', name: 'Channel 56' },
  { id: '60', name: 'Channel 60' },
  { id: '64', name: 'Channel 64' },
  { id: '100', name: 'Channel 100' },
  { id: '104', name: 'Channel 104' },
  { id: '108', name: 'Channel 108' },
  { id: '112', name: 'Channel 112' },
  { id: '116', name: 'Channel 116' },
  { id: '120', name: 'Channel 120' },
  { id: '124', name: 'Channel 124' },
  { id: '128', name: 'Channel 128' },
  { id: '132', name: 'Channel 132' },
  { id: '136', name: 'Channel 136' },
  { id: '140', name: 'Channel 140' },
  { id: '149', name: 'Channel 149' },
  { id: '153', name: 'Channel 153' },
  { id: '157', name: 'Channel 157' },
  { id: '161', name: 'Channel 161' },
  { id: '165', name: 'Channel 165' },
];

export const PotscastWireless5GModeOpt = [
  { id: '14', name: '11a/n/ac mixed mode' },
  { id: '15', name: '11n/ac mixed mode' },
  { id: '11', name: '11n only' },
];

export enum AcsAtaProfileType {
  VOIP = 'voip',
  MOIP = 'moip',
  ALARM = 'alarm',
  ALARM_XMTR = 'alarm_xmtr',
  FAX_XMTR = 'fax_xmtr',
  FAX = 'fax',
  ELEVATOR = 'elevator',
}

export const PotscastLineTypeOptions = [
  { id: AcsAtaProfileType.ALARM, name: 'Alarm' },
  { id: AcsAtaProfileType.ELEVATOR, name: 'Elevator' },
  { id: AcsAtaProfileType.FAX, name: 'FAX' },
  { id: AcsAtaProfileType.MOIP, name: 'Modem' },
  { id: AcsAtaProfileType.VOIP, name: 'Voice' },
];

export const PotscastAuthModeOpt = [
  { id: '', name: 'Disabled' },
  { id: '0', name: 'Disabled' },
  { id: 'WPAPSK', name: 'WPA-PSK' },
  { id: 'WPA2PSK', name: 'WPA2-PSK' },
  { id: 'WPAPSKWPA2PSK', name: 'WPA-PSK/WPA2-PSK' },
  { id: 'WPA3PSK', name: 'WPA3-PSK' },
];

export const NUMBER_TYPE_OPTIONS = Object.values(BandwidthPhoneTypeEnum).map(value => ({ id: value, name: value }));

export const CosTypeOptions = [
  { id: OrigRouteCosDestClassDestType.BG, name: OrigRouteCosDestClassDestType.BG },
  { id: OrigRouteCosDestClassDestType.BG_RR, name: OrigRouteCosDestClassDestType.BG_RR },
  { id: OrigRouteCosDestClassDestType.CLASS5ARENA, name: OrigRouteCosDestClassDestType.CLASS5ARENA },
  { id: OrigRouteCosDestClassDestType.VM, name: OrigRouteCosDestClassDestType.VM },
  { id: OrigRouteCosDestClassDestType.PSTN, name: OrigRouteCosDestClassDestType.PSTN },
];

export const PotscastWANModeOpt = [
  { id: '0', name: 'Single Mode' },
  { id: '1', name: 'Hot Failover' },
];

export const PotscastWAN1And2Opt = [
  { id: '0', name: 'ETH WAN1' },
  { id: '1', name: 'ETH WAN2' },
  { id: '2', name: 'LTE WAN' },
  { id: '3', name: 'WWAN' },
];

export const PotscastWAN3And4Opt = [
  { id: '0', name: 'ETH WAN1' },
  { id: '1', name: 'ETH WAN2' },
  { id: '2', name: 'LTE WAN' },
  { id: '3', name: 'WWAN' },
  { id: '4', name: 'Disable' },
];

export const PotscastPoEOpt = [
  { id: '0', name: 'Disable' },
  { id: '1', name: '12V' },
  { id: '2', name: '24V' },
  { id: '3', name: '48V' },
];

export const potscastInitSections: Array<{
  name: string;
  fields: Array<{ name: string; options?: Array<{ id: string; name: string }> }>;
}> = [
  {
    name: 'wifi24GHzSettings',
    fields: [
      { name: 'WiFiOff', options: PotscastBoolOpt },
      { name: 'WirelessMode', options: PotscastWirelessModeOpt },
      { name: 'SSID1' },
      { name: 'Channel', options: PotscastChannelOpt },
      { name: 'HideSSID' },
      { name: 'HT_BW' },
    ],
  },
  {
    name: 'wifi24GHzSecurity',
    fields: [{ name: 'AuthMode', options: PotscastAuthModeOpt }, { name: 'EncrypType' }, { name: 'WPAPSK1' }],
  },
  {
    name: 'wifi5GHzSettings',
    fields: [
      { name: '5G_WiFiOff', options: PotscastBoolOpt },
      { name: '5G_WirelessMode', options: PotscastWireless5GModeOpt },
      { name: '5G_SSID1' },
      { name: '5G_Channel', options: PotscastChannel5GOpt },
      { name: '5G_HideSSID' },
      { name: '5G_VHT_BW' },
    ],
  },
  {
    name: 'wifi5GHzSecurity',
    fields: [{ name: '5G_AuthMode', options: PotscastAuthModeOpt }, { name: '5G_EncrypType' }, { name: '5G_WPAPSK1' }],
  },
  {
    name: 'wanSettings',
    fields: [
      { name: 'multiwanmode', options: PotscastWANModeOpt },
      { name: 'fo_mainwan', options: PotscastWAN1And2Opt },
      { name: 'fo_backwan', options: PotscastWAN1And2Opt },
      { name: 'fo_thirdwan', options: PotscastWAN3And4Opt },
      { name: 'fo_fourthwan', options: PotscastWAN3And4Opt },
      { name: 'fo_icmp1' },
      { name: 'fo_icmp2' },
      { name: 'fo_icmpinterval' },
      { name: 'fo_icmptimeout' },
      { name: 'fo_icmpretries' },
    ],
  },
  {
    name: 'networkManagementSettings',
    fields: [
      { name: 'RemoteManagement', options: PotscastNotBoolOpt },
      { name: 'remoteipaddr' },
      { name: 'remoteport' },
      { name: 'RemoteManagementHttps', options: PotscastNotBoolOpt },
      { name: 'remoteipaddr_https' },
      { name: 'remoteport_https' },
      { name: 'HTTP_management', options: PotscastNotBoolOpt },
      { name: 'HTTPS_management', options: PotscastNotBoolOpt },
      { name: 'WANPingFilter', options: PotscastNotBoolOpt },
      { name: 'PingFilter', options: PotscastNotBoolOpt },
    ],
  },
  {
    name: 'lteSettings',
    fields: [
      { name: 'sim_policy_enable', options: PotscastNotBoolOpt },
      { name: 'SIM_Position', options: PotscastSIMOpt },
      { name: 'dualsim_sim1ping_ip' },
      { name: 'dualsim_sim1ping_ip2' },
      { name: 'dualsim_sim1ping_between' },
      // SIM 1
      { name: 'DataRoaming', options: PotscastNotBoolOpt },
      { name: 'lte_data1' },
      { name: 'sim1_default_apn_mode', options: PotscastAPNModeOpt },
      { name: 'sim1_default_apn_pdp', options: PotscastAPNPDPOpt },
      { name: 'sim1_default_apn_apn' },
      { name: 'sim1_default_apn_auth', options: PotscastAPNAuthOpt },
      { name: 'sim1_default_apn_user' },
      { name: 'sim1_default_apn_pw' },
      { name: 'sim1_default_apn_plmn' },
      // SIM 2
      { name: 'DataRoaming_sim2', options: PotscastNotBoolOpt },
      { name: 'lte_data2' },
      { name: 'sim2_default_apn_mode', options: PotscastAPNModeOpt },
      { name: 'sim2_default_apn_pdp', options: PotscastAPNPDPOpt },
      { name: 'sim2_default_apn_apn' },
      { name: 'sim2_default_apn_auth', options: PotscastAPNAuthOpt },
      { name: 'sim2_default_apn_user' },
      { name: 'sim2_default_apn_pw' },
      { name: 'sim2_default_apn_plmn' },
    ],
  },
  { name: 'poe1VoltageSettings', fields: [{ name: 'wan1_poe_voltage', options: PotscastPoEOpt }] },
  { name: 'poe2VoltageSettings', fields: [{ name: 'wan2_poe_voltage', options: PotscastPoEOpt }] },
  {
    name: 'natSettings',
    fields: [
      { name: 'voip_nat_mode', options: PotscastNatTraversal },
      { name: 'nat_keep', options: PotscastNatKeep },
    ],
  },
  {
    name: 'dcSettings',
    fields: [{ name: 'dc_out_enable', options: PotscastNotBoolOpt }, { name: 'dc_out_cycle_time' }],
  },
];

export const potscastPortInitSections: Array<{
  name: string;
  fields: Array<{ name: string; options?: Array<{ id: string; name: string }> }>;
}> = [
  {
    name: 'allSettings',
    fields: [
      { name: 'voip_transfer_type', options: PotscastTransportOpt },
      { name: 'proxydns', options: PotscastProxyOpt },
      { name: 'hot_line' },
      { name: 'voip_max_jitter' },
      { name: 'voip_min_jitter' },
      { name: 'dial_timeout' },
      { name: 'voip_echo_cancel', options: PotscastNotBoolOpt },
      { name: 'enable_gpmd', options: PotscastNotBoolOpt },
      { name: 'dtmf_type', options: PotscastDTMFOpt },
      {
        name: 'voip_dtmf_volume_level',
        options: generateNumberOptions(-20, 0, 1).map(o => ({ id: `${o.id}`, name: o.name })),
      },
      {
        name: 'voip_ring_voltage_mode',
        options: generateNumberOptions(0, 75, 1).map(o => ({ id: `${o.id}`, name: o.name })),
      },
      {
        name: 'voip_on_hook_voltage',
        options: generateNumberOptions(36, 57, 1).map(o => ({ id: `${o.id}`, name: o.name })),
      },
      { name: 'sip_rfc2883_payload' },
      { name: 'sip_early_media', options: PotscastNotBoolOpt },
      { name: 'sip_p_pearly_media', options: PotscastNotBoolOpt },
      { name: 'call_wait', options: PotscastNotBoolOpt },
      { name: 'sip_callwait_callerid', options: PotscastNotBoolOpt },
      { name: 'voip_cpc_enable', options: PotscastNotBoolOpt },
      { name: 'voip_cpc_delay' },
      { name: 'voip_cpc_durat' },
    ],
  },
];

export enum LeadType {
  VERIZON = 'VERIZON',
  CSG = 'CSG',
  OTHER = 'OTHER',
}

export const leadTypeOptions = Object.values(LeadType).map(name => ({ id: name, name }));

export const leadLogTypeOptions = [
  { id: LeadLogEnum.LEAD_CREATED, name: 'Lead Created' },
  { id: LeadLogEnum.LEAD_CONTACT_CREATED, name: 'Lead Contact Created' },
  { id: LeadLogEnum.LEAD_NOTES_UPDATED, name: 'Lead Notes Updated' },
  { id: LeadLogEnum.LEAD_STATUS_UPDATED, name: 'Lead Status Updated' },
  { id: LeadLogEnum.LEAD_PIPELINE_STAGE_UNKNOWN, name: 'Lead Pipeline Stage Unknown' },
  { id: LeadLogEnum.LEAD_CONTACT_NOT_CREATED, name: 'Lead Contact Not Created' },
  { id: LeadLogEnum.LEAD_STATUS_UPDATED_FAILED, name: 'Lead Status Updated Failed' },
];

export const releaseNotesStatusFilterOptions = [
  { id: 'Coming Soon', name: 'Coming Soon' },
  { id: 'Released', name: 'Released' },
];
